// extracted by mini-css-extract-plugin
export default {"historyNav":"HistoryMenu_historyNav__54kv1","fadeSlide":"HistoryMenu_fadeSlide__8ShbZ","historyLink":"HistoryMenu_historyLink__xLT9T"};